export const TRADING_MODES = {
  BACKTESTING: "backtesting",
  LIVE: "live",
};

export const TRADING_MODE_LABELS = {
  [TRADING_MODES.BACKTESTING]: "Backtesting",
  [TRADING_MODES.LIVE]: "Live Trading",
};

export const STORAGE_KEYS = {
  ACTIVE_MODE: "activeTradingMode",
  PREFERRED_MODE: "preferredTradingMode",
  REMEMBER_MODE: "rememberTradingMode",
  LIVE_CONFIRMED: "liveModeConfirmed",
};

const isBrowser = typeof window !== "undefined";

export const isValidTradingMode = (mode) =>
  mode === TRADING_MODES.BACKTESTING || mode === TRADING_MODES.LIVE;

export const getModeLabel = (mode) => TRADING_MODE_LABELS[mode] || "Trading";

export const getRememberMode = () => {
  if (!isBrowser) {
    return false;
  }
  return localStorage.getItem(STORAGE_KEYS.REMEMBER_MODE) === "true";
};

export const getPreferredMode = () => {
  if (!isBrowser) {
    return null;
  }
  const mode = localStorage.getItem(STORAGE_KEYS.PREFERRED_MODE);
  return isValidTradingMode(mode) ? mode : null;
};

export const getSessionMode = () => {
  if (!isBrowser) {
    return null;
  }
  const mode = sessionStorage.getItem(STORAGE_KEYS.ACTIVE_MODE);
  return isValidTradingMode(mode) ? mode : null;
};

export const getInitialMode = () => {
  const sessionMode = getSessionMode();
  if (sessionMode) {
    return sessionMode;
  }

  if (getRememberMode()) {
    return getPreferredMode();
  }

  return null;
};

export const persistModeSelection = (mode, remember) => {
  if (!isBrowser || !isValidTradingMode(mode)) {
    return null;
  }

  sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MODE, mode);

  if (remember) {
    localStorage.setItem(STORAGE_KEYS.REMEMBER_MODE, "true");
    localStorage.setItem(STORAGE_KEYS.PREFERRED_MODE, mode);
  } else {
    localStorage.setItem(STORAGE_KEYS.REMEMBER_MODE, "false");
    localStorage.removeItem(STORAGE_KEYS.PREFERRED_MODE);
  }

  return mode;
};

export const syncModeOnNavigation = (mode) => {
  if (!isBrowser || !isValidTradingMode(mode)) {
    return;
  }

  sessionStorage.setItem(STORAGE_KEYS.ACTIVE_MODE, mode);
  if (getRememberMode()) {
    localStorage.setItem(STORAGE_KEYS.PREFERRED_MODE, mode);
  }
};

export const clearSessionMode = () => {
  if (!isBrowser) {
    return;
  }
  sessionStorage.removeItem(STORAGE_KEYS.ACTIVE_MODE);
};

export const isLiveModeConfirmed = () => {
  if (!isBrowser) {
    return false;
  }
  return sessionStorage.getItem(STORAGE_KEYS.LIVE_CONFIRMED) === "true";
};

export const setLiveModeConfirmed = () => {
  if (!isBrowser) {
    return;
  }
  sessionStorage.setItem(STORAGE_KEYS.LIVE_CONFIRMED, "true");
};

export const clearLiveModeConfirmed = () => {
  if (!isBrowser) {
    return;
  }
  sessionStorage.removeItem(STORAGE_KEYS.LIVE_CONFIRMED);
};

export const getStrategyStorageKey = (mode) =>
  isValidTradingMode(mode) ? `currentStrategy:${mode}` : "currentStrategy";
